import React, { useMemo, useState } from 'react';
import SettingsOption from '../SettingsOption';

import { useFormikContext } from 'formik';
import { MdEditDocument } from 'react-icons/md';
import WaiverModal, { Waiver } from './WaiverModal';
import { cloneDeep } from 'lodash';

interface InitialWaiver {
  content: string;
  title: string;
  _id: string;
}

const WaiverSetting = ({ refetchEvent }: { refetchEvent: () => void }) => {
  const { values } = useFormikContext<any>();

  const [showWaiverModal, setShowWaiverModal] = useState(false);

  const toggleWaiverModal = () => {
    setShowWaiverModal((showWaiverModal) => !showWaiverModal);
  };

  const waivers: Waiver[] = useMemo(
    () =>
      values?.waivers?.length > 0
        ? cloneDeep(
            values.waivers.map((waiver: InitialWaiver) => ({
              content: waiver.content,
              title: waiver.title,
              id: waiver._id
            }))
          )
        : [{ content: '', title: '', id: '' }],
    [values?.waivers]
  );

  return (
    <>
      <SettingsOption
        icon={<MdEditDocument size={20} />}
        title="Waiver"
        actionLabel="Add waiver"
        value={values?.waivers?.length && `${values?.waivers?.length} total`}
        onClick={toggleWaiverModal}
        tooltipMessage="Specify a waiver which guests will need to accept before purchasing or claiming a ticket."
      />
      {showWaiverModal && (
        <WaiverModal
          refetchEvent={refetchEvent}
          eventId={values._id}
          onClose={toggleWaiverModal}
          initialValues={{
            waivers
          }}
        />
      )}
    </>
  );
};

export default WaiverSetting;
